import { genId } from "@smartsheet/lodestar-utils";

export const GROW_WRAPPER_CLASS = genId("textarea-grow-wrapper");
